/**
 * Local storage module
*/

import EventBus from './../event-bus.js'


class StorageModule {
    
    /**
     * Construct module
    */
    constructor(elements) {
        
        /**
         * Whether local storage is supported
         * @type boolean
        */
        this.isSupported = this.checkSupport()
        
        this.bindEvents()
        
    }
    
    /**
     * Determine whether local storage is supported
     * @return boolean
    */
    checkSupport () {
        
        let mod = 'test'
        
        try {
            localStorage.setItem(mod, mod)
            localStorage.removeItem(mod)
            return true
        }
        catch (e) {
            return false
        }
        
    }
    
    /**
     * Write to storage
     * @params params
    */
    write({key, value, type = ''} = {}) {
        if (this.isSupported) {
            this.getStorageApi(type).setItem(key, value)
        }
    }
    
    /**
     * Read from storage
     * @param params
    */
    read({callback, key, type = ''} = {}) {
        callback(this.isSupported ? this.getStorageApi(type).getItem(key) : null)
    }
    
    /**
     * Clear from storage
     * @param key
     * @param params
    */
    clear(key, {type = ''} = {}) {
        if (this.isSupported) {
            this.getStorageApi(type).removeItem(key)
        }
    }
    
    /**
     * Get storage API
     * @param type
     * @return object
    */
    getStorageApi(type) {
        return (type == 'session' ? sessionStorage : localStorage)
    }
    
    /**
     * Bind events
    */
    bindEvents() {
        
        EventBus
            .subscribe('storage.read', this.read.bind(this))
            .subscribe('storage.write', this.write.bind(this))
            .subscribe('storage.clear', this.clear.bind(this))
        
    }
    
}

EventBus.subscribe('init-modules',  () => {
    new StorageModule()
})

export default StorageModule